var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46875 9C6.46875 7.60444 7.60444 6.46875 9 6.46875C10.3956 6.46875 11.5312 7.60444 11.5312 9C11.5312 9.36731 11.4508 9.7155 11.3096 10.0311L9.639 8.36044L8.361 9.639L10.0316 11.3096C9.70731 11.4557 9.35568 11.5312 9 11.5312C8.3289 11.5305 7.6855 11.2636 7.21096 10.789C6.73642 10.3145 6.46949 9.6711 6.46875 9ZM13.1136 9C13.1143 8.2055 12.8836 7.42797 12.4498 6.76238L14.0625 5.14913L12.8509 3.9375L11.2376 5.55075C10.593 5.13169 9.82575 4.88644 9 4.88644C8.17425 4.88644 7.407 5.13169 6.76238 5.55019L5.14913 3.9375L3.9375 5.14913L5.55075 6.76238C5.13169 7.407 4.88644 8.17425 4.88644 9C4.88644 9.82575 5.13225 10.593 5.55075 11.2376L3.9375 12.8509L5.14913 14.0625L6.76238 12.4493C7.407 12.8683 8.17425 13.1136 9 13.1136C9.82575 13.1136 10.593 12.8683 11.2376 12.4493L12.8509 14.0625L14.0625 12.8509L12.4493 11.2376C12.8833 10.5721 13.1142 9.79456 13.1136 9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQsp);
export default __webpack_public_path__ + "static/media/qsp.98b6cfdf058ef062012d7ce3d6b1e93c.svg";
export { ForwardRef as ReactComponent };